{
	"article": {
		"no-blog-found": "Ekkert blogg fannst",
		"no-news-found": "Engar fréttir fundust",
		"something-went-wrong": "Eitthvað fór úrskeiðis, tókst ekki að sækja gögn."
	},
	"allow-location-text": "Sjáðu það pósthús, Póstbox eða Pakkaport sem er næst þér með því að deila staðsetningunni þinni.",
	"allow-location": "Sýna staðsetningu",
	"shipment": {
		"find-shipment": "Finna sendingu",
		"register-shipment": "Skrá sendingu",
		"enter-a-shipment-number": "Sláðu inn sendingarnúmer",
		"search-for-shipment": "Leita að sendingu",
		"register-shipment-info": "Flýttu fyrir póstlagningu með því að skrá sendingu á vefnum áður en komið er með pakkann á pósthús.",
		"send-receipt": "Senda inn reikning"
	},
	"invoice": {
		"send-invoice": "Senda reikning"
	},
	"post-office": {
		"find-post-office": "Finna pósthús",
		"post-office": "Pósthús",
		"post-office_lowercase": "pósthús",
		"post-office-or-post-box": "Pósthús eða Póstbox",
		"post-offices-near-you": "Pósthús nálægt þér",
		"see-all-post-offices": "Sjá öll pósthús"
	},
	"post-box": {
		"post-box": "Póstbox",
		"see-all": "Sjá öll Póstbox",
		"text": "Sjá öll Póstbox",
		"post-box_lowercase": "póstbox",
		"see-all-post-boxes": "Sjá öll Póstbox",
		"post-box-near-you": "Póstbox nálægt þér"
	},
	"parcel-point": {
		"parcel-point": "Pakkaport",
		"parcel-point-near-you": "Pakkaport nálægt þér",
		"see-all-parcel-points": "Sjá öll pakkaport"
	},
	"opening-hours": {
		"opening-hours": "Opnunartímar",
		"see-all": "Sjá nánar",
		"text": "Finndu opnunartíma og staðsetningar allra pósthúsa og póstboxa"
	},
	"post-code": {
		"search-by-post-code": "Leita eftir póstnúmeri"
	},
	"services": {
		"order-home-delivery": "Panta heimsendingu"
	},
	"misc": {
		"telephone": "Sími",
		"email": "Netfang",
		"map-unavailable": "Kortið er ekki tiltækt í augnablikinu. Vinsamlegast notaðu staðsetningarupplýsingarnar eða reyndu aftur síðar.",
		"opening-hours": "Opnunartímar",
		"see-on-map": "Sjá á korti",
		"questions-and-answers": "Algengar spurningar",
		"24/7": "Allan sólarhringinn"
	},
	"name": "Nafn",
	"price-without-importduty": "Verð án VSK",
	"description": "Lýsing",
	"success-failure": {
		"thereWasAnError": "Aðgerð tókst ekki",
		"thereWasAnErrorText": "Búið er að senda póst á kerfisstjóra. Ef að þetta er áríðandi hafðu þá samband við þjónustuver",
		"success": "Aðgerð tókst",
		"open-pdf": "Ef pdf skjalið opnast ekki sjálfkrafa, ýttu þá á hlekkinn fyrir neðan til að opna það.",
		"print-pdf": "Athugaði að prenta fylgiskjal út og látið það fylgja Póstinum við póstlagningu.",
		"open-pdf-link": "Opna pdf skjal"
	},
	"captchaValid": "Ekki rétt, reyndu aftur",
	"refresh": "Endurhlaða",
	"error": {
		"error-heading": "Eitthvað fór úrskeiðis",
		"error-postoffice": "Gat ekki sótt pósthús",
		"error-postbox": "Gat ekki sótt póstbox",
		"error-parcelpoint": "Gat ekki sótt pakkaport",
		"error-countries": "Gat ekki sótt áfangastaði",
		"error-postCodes": "Gat ekki sótt póstföng",
		"error-subtext": "Búið er að láta kerfisstjóra vita",
		"error-500-unknown": "Eitthvað fór úrskeiðis",
		"error-try-refresh": "Prufaðu að endurhlaða síðunni"
	},
	"header": {
		"close": "Loka",
		"search": "Leita",
		"search-path": "/leit",
		"minn-postur": "Mínar síður",
		"register-shipment": "Skrá sendingu",
		"find-shipment": "Finna sendingu"
	},
	"footer": {
		"follow-us-on-social-media": "Fylgstu með okkur á samfélagsmiðlum",
		"jlv-cert": "Jafnlaunavottun",
		"bsi-cert": "ISO 9001 vottun",
		"vog-2021": "Jafnvægisvog 2021"
	},
	"accept": "Loka",
	"bubble": {
		"help": "Hvernig getum við aðstoðað?",
		"chat": "Netspjall",
		"email": "Hafðu samband",
		"tips": "Ábendingar, kvartanir, hrós"
	},
	"price": "Verð",
	"price-from": "Verð frá",
	"price-estimated": "Áætlað verð",
	"more": "Nánar",
	"see-more": "Sjá nánar",
	"mainPhone": "Aðalsími",
	"individual": "Einstaklingar",
	"choose-month": "Veldu mánuð",
	"choose-year": "Veldu ár",
	"choose-none": "Sýna allt",
	"dimension": "Skráðu rúmmál pakkans",
	"dimension-text": "Ef pakkinn er stærri en 20x30x50 cm þá verður hann rúmmálsmældur við sendingu. Settu inn málin á pakkanum hér að neðan til að fá rétt verð.",
	"width-cm": "Breidd (cm)",
	"height-cm": "Hæð (cm)",
	"length-cm": "Lengd (cm)",
	"width": "Breidd",
	"height": "Hæð",
	"length": "Lengd",
	"company": "Fyrirtæki",
	"calculator": "Reiknaðu hvað kostar að senda pakka til útlanda",
	"applyForJob": "Sækja um starf",
	"fullTime": "Fastráðning",
	"summerJobs": "Sumarstörf",
	"theApp": "Appið",
	"show": "Sýna",
	"hide": "Fela"
}
